import React from 'react'
import PropTypes from 'prop-types'

import pluralize from 'pluralize'
import { Card, List } from 'semantic-ui-react'

import CardProperty from 'Components/CardProperty'
import Permissions from 'Components/Permissions'

import * as rugHelpers from 'Global/Helpers/rugHelpers'

const RugCardPictureSource = ({ enablePreview, rug, togglePreview }) => {
  if (rug.pictureSource || rug.pictureCount) {
    return (
      <Permissions
        permissions={['rug.field.pictureCount', 'rug.field.pictureSource']}
        render={() => (
          <Card.Content extra>
            <List>
              {rug.pictureCount ? (
                <Permissions
                  permissions="rug.field.pictureCount"
                  render={() => (
                    <CardProperty icon="picture" popUpContent={pluralize('Picture', rug.pictureCount)}>
                      {`${rug.pictureCount} ${pluralize('Picture', rug.pictureCount)}`}
                    </CardProperty>
                  )}
                />
              ) : null}

              {rug.pictureSource ? (
                <Permissions
                  permissions="rug.field.pictureSource"
                  render={() => (
                    <CardProperty icon="camera" onClick={enablePreview ? togglePreview : null} popUpContent="Primary Picture Source">
                      {rugHelpers.getPictureSourceString(rug.pictureSource)}
                    </CardProperty>
                  )}
                />
              ) : null}
            </List>
          </Card.Content>
        )}
        renderElse={() => (
          <Card.Content extra>
            <List>
              {rug.pictureSource ? (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a onClick={enablePreview ? togglePreview : null}>
                  <CardProperty icon="camera" popUpContent="Preview">
                    Preview
                  </CardProperty>
                </a>
              ) : null}
            </List>
          </Card.Content>
        )}
      />
    )
  } else {
    return null
  }
}

RugCardPictureSource.propTypes = {
  enablePreview: PropTypes.bool.isRequired,
  rug: PropTypes.object.isRequired,
  togglePreview: PropTypes.func.isRequired,
}

export default RugCardPictureSource
